module.exports = __webpack_public_path__ + "img/android-glider.cc7b78b5.svg";